module.exports = __webpack_public_path__ + "static/media/excel.385bfa9e.svg";